import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Form,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
} from "reactstrap";
import cx from "classnames";

import {
  DOCUMENT_PUBLISH_SUCCESS,
  DOCUMENT_PUBLISH_FAILED,
  DOCUMENT_PUBLISH_SET_PASSWORD_SUCCESS,
  DOCUMENT_PUBLISH_SET_PASSWORD_FAILED,
  DOCUMENT_PUBLISH_UNSET_PASSWORD_SUCCESS,
  DOCUMENT_PUBLISH_UNSET_PASSWORD_FAILED,
  DOCUMENT_UNPUBLISH_SUCCESS,
  DOCUMENT_UNPUBLISH_FAILED,
  DOCUMENT_PUBLISH_HANDLE_DOWNLOAD_FAILED,
  DOCUMENT_PUBLISH_HANDLE_DOWNLOAD_SUCCESS,
  DOCUMENT_PUBLISH_HANDLE_BADGE_SUCCESS,
  DOCUMENT_PUBLISH_HANDLE_BADGE_FAILED,
  DOCUMENT_PUBLISH_EMAIL_VERIFICATION_SUCCESS,
  DOCUMENT_PUBLISH_EMAIL_VERIFICATION_FAILED,
  FOLLOW_UP_REMINDER_DOCUMENT_SUCCESS,
  FOLLOW_UP_REMINDER_DOCUMENT_FAILED,
} from "../../../store/actions/actionTypes";
import { getUserInfo } from "../../../store/actions/authActions";
import {
  fetchDocumentDetails,
  publishDocument,
  publishDocumentEmailVerification,
  publishDocumentHandleBadge,
  publishDocumentHandleDownload,
  publishDocumentSetPassword,
  publishDocumentUnsetPassword,
  toggleNavigation,
  unpublishDocument,
  unsetDocumentExpiryDate,
  updateDocumentExpiryDate,
  updateDocumentSignedStatus,
  proposalEnableFollowUpReminder,
} from "../../../store/actions/documentActions";
import { preventFormSubmitOnEnter as preventSubmit } from "../../../_helpers/utils";
import { documentInfo } from "../_utils";
import { Input } from "../../ui/input";
import { Icon } from "../../ui/icon";
import { ProcessLoader } from "../../ui/loader/processLoader";
import { FlashAlert } from "../../ui/flashAlert";
import { useSocket } from "../../../hooks/useSocket";
import {
  PUBLISH_DOCUMENT,
  PUBLISH_DOCUMENT_DOWNLOAD,
  PUBLISH_DOCUMENT_PASSWORD,
  UNPUBLISH_DOCUMENT,
} from "../../../constants/socket";

import global from "../../../scss/dhp.scss";
import thumbsUpSvg from "../../../assets/images/ui-thumbs-up.svg";
import sourceCodeSvg from "../../../assets/images/ui-source-code.svg";
import Crown from "../../../assets/images/ui-crown.svg";
import { useContextualUpgrade } from "../../../hooks/useContextualUpgrade";
import { useCheckCompanyPlanInfo } from "../../../hooks/useCheckCompanyPlanInfo";
import { COMPANY_SUPERADMIN } from "../../../constants/company";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import TabSchemeSelector from "../../Common/TabSchemeSelector";
import { getCompanyInfo } from "../../../store/actions/companyActions";
import { TYPE_PROPOSAL } from "../../../constants/editor";
import { fetchSignerList } from "../../../store/actions/editorActions";
import Modal from "../../ui/modal";
import ProposalStatusChangeModal from "../../Editor/Modals/ProposalStatusChangeModal";
import ColumnLayoutLoader from "../../ui/loader/columnLayoutLoader";
import SingleLineLoader from "../../ui/loader/singleLineLoader";

let style = Object.assign({}, global);

const Settings = ({ source, data, _helpers, documentrawData }) => {
  const contextData = useContext(EditorContext);
  const webSocket = useSocket();
  const dispatch = useDispatch();

  const docType = document.getElementById("editorBody")
    ? contextData.documentType
    : data.template_info.type.toLowerCase();

  // useContextualUpgrade Hook to show update modal
  const showUpgrade = useContextualUpgrade();

  // check is this company is paid or not
  const paidCompanyInfo = useCheckCompanyPlanInfo(true);

  const companyId = useSelector(state => state.auth?.user?.company?.id);
  const modifiedData = { ...data.publish, publish_id: data?.publish?.hash, id: data?.id };
  const companyData = useSelector(state => state?.auth?.company);
  const dateFormat = (useSelector(state => state?.auth?.user?.date_format) || "MM-DD-YYYY").replaceAll("-", "/");
  const userInfo = useSelector(state => state?.auth?.user);
  const { type, hash_code: publish_id, documentDetails } = useSelector(state => state?.document);
  const authState = useSelector(state => state?.auth);

  const documentId = documentDetails?.data?.id;
  const alertData = {
    show: false,
    type: "",
  };
  const processEndTypes = {
    publish: [DOCUMENT_PUBLISH_SUCCESS, DOCUMENT_PUBLISH_FAILED],
    unpublish: [DOCUMENT_UNPUBLISH_SUCCESS, DOCUMENT_UNPUBLISH_FAILED],
    set_password: [DOCUMENT_PUBLISH_SET_PASSWORD_SUCCESS, DOCUMENT_PUBLISH_SET_PASSWORD_FAILED],
    unset_password: [DOCUMENT_PUBLISH_UNSET_PASSWORD_SUCCESS, DOCUMENT_PUBLISH_UNSET_PASSWORD_FAILED],
    download: [DOCUMENT_PUBLISH_HANDLE_DOWNLOAD_SUCCESS, DOCUMENT_PUBLISH_HANDLE_DOWNLOAD_FAILED],
    badge: [DOCUMENT_PUBLISH_HANDLE_BADGE_SUCCESS, DOCUMENT_PUBLISH_HANDLE_BADGE_FAILED],
    email_verification: [DOCUMENT_PUBLISH_EMAIL_VERIFICATION_SUCCESS, DOCUMENT_PUBLISH_EMAIL_VERIFICATION_FAILED],
    follow_up_reminder: [FOLLOW_UP_REMINDER_DOCUMENT_SUCCESS, FOLLOW_UP_REMINDER_DOCUMENT_FAILED],
  };
  const errorTypes = [
    DOCUMENT_PUBLISH_FAILED,
    DOCUMENT_PUBLISH_SET_PASSWORD_FAILED,
    DOCUMENT_PUBLISH_UNSET_PASSWORD_FAILED,
    DOCUMENT_UNPUBLISH_FAILED,
    DOCUMENT_PUBLISH_HANDLE_DOWNLOAD_FAILED,
    DOCUMENT_PUBLISH_HANDLE_BADGE_FAILED,
    DOCUMENT_PUBLISH_EMAIL_VERIFICATION_FAILED,
  ];
  const publishFieldIds = {
    link: "document-publish-link",
    embed: "document-publish-embed",
  };
  const socialShareOptions = [
    {
      name: "facebook",
      tooltip: "Facebook",
      className: "fb",
      iconClassName: "facebook",
    },
    {
      name: "twitter",
      tooltip: "X/Twitter",
      className: "tw",
      iconClassName: "twitterx",
    },
    {
      name: "linkedin",
      tooltip: "Linkedin",
      className: "lin",
      iconClassName: "linkedin",
    },
    {
      name: "whatsapp",
      tooltip: "WhatsApp",
      className: "whatsapp",
      iconClassName: "ui-whatsapp",
    },
    // {
    //   name: "skype",
    //   tooltip: "Skype",
    //   className: "skype",
    //   iconClassName: "ui-skype",
    // },
  ];
  const { exists: isPublished, data: publishId } = documentInfo.get(modifiedData, "publish_id");
  const { exists: isPasswordEnabled } = documentInfo.get(modifiedData, "password");
  const { data: isDownloadEnabled } = documentInfo.get(modifiedData, "download");
  const { data: isBadgeEnabled } = documentInfo.get({ ...companyData, id: data?.id }, "hide_badge");
  const { exists: isEmailVerificationEnabled, data: isEmailVerificationData } = documentInfo.get(
    modifiedData,
    "email_verification"
  );

  const publishSchemes = ["General", docType === TYPE_PROPOSAL && "Proposal Settings", "Other Settings"].filter(
    Boolean
  );
  const verificationTypes = {
    ["AE"]: "Any Email",
    ["SE"]: "Specific Email",
    ["ED"]: "Email Domain",
  };

  const initialState = {
    email: {
      payload: {
        publishLink: "",
      },
    },
    published: isPublished,
    download_enabled: isDownloadEnabled,
    password_enabled: isPasswordEnabled,
    publish_id: publishId,
    toggle_publish: isPublished,
    toggle_set_password: isPasswordEnabled,
    dochipo_badge_enabled: isBadgeEnabled,
    enabled_follow_up: documentDetails?.data?.proposal?.followup_reminder || false,
    email_verification_enabled: isEmailVerificationEnabled,
    toggle_email_verification: isEmailVerificationEnabled,
    password: {
      value: "",
      validation: {
        required: true,
        min_length: 6,
        max_length: 25,
      },
      placeholder: isPasswordEnabled ? "******" : `Minimum 6 characters`,
      touched: false,
      valid: false,
      error: "",
    },
    set_password_button_label: isPasswordEnabled ? "Change" : "Save",
    tab: "social_media",
    email_verification: {
      value: isEmailVerificationData?.value || "",
      displayValue: (isEmailVerificationData && isEmailVerificationData?.value) || "",
      validation: {
        required: true,
      },
      verification_type_dropdown: {
        selected: {
          name: isEmailVerificationData ? isEmailVerificationData.key : "Any Email",
          value: isEmailVerificationData ? isEmailVerificationData.key : "Any Email",
        },
      },
      placeholder: "neel@gmail.com, sam@gmail.com",
      email_domain_placeholder: "example.com, domain.com",
      valid: false,
    },
    proposal_show_navigation_enabled: false,
    toggl_proposal_show_navigation_enabled: false,
    proposal_settings: {
      value: "",
      status:
        documentDetails?.data?.proposal?.status === "live" ||
        documentDetails?.data?.proposal?.status === "partially_signed"
          ? { name: "Live", color: "#fcc419", tooltipShow: false }
          : documentDetails?.data?.proposal?.status === "signed"
          ? { name: "Accepted", color: "#40c057", tooltipShow: false, disableName: false }
          : { name: "Declined", color: "#b9310c", tooltipShow: false, disableName: false },
    },
  };

  const loaderConfig = {
    layout: 1,
    section: 1,
    col_per_section: {
      1: 2,
    },
    show_page_label: true,
    show_section_label: false,
    show_field_label: true,
    show_field: true,
    loader_height: "200px",
  };

  const [state, setState] = useState(initialState);
  const [isMounted, setIsMounted] = useState(false);
  const [isPasswordSuccessResponse, setIsPasswordSuccessResponse] = useState("");
  const [alert, setAlert] = useState(alertData);
  const [linkCopied, setLinkCopied] = useState(false);
  const [embedCopied, setEmbedCopied] = useState(false);
  const [isUserDocumentOwner, setIsUserDocumentOwner] = useState(false);
  const [disable, setDisable] = useState({
    publish: false,
    unpublish: false,
    set_download: false,
    unset_download: false,
    set_password: false,
    unset_password: false,
    set_badge_enable: false,
    unset_badge_enable: false,
    set_follow_up_reminder: false,
    unset_follow_up_reminder: false,
  });
  const [disableEmail, setDisableEmail] = useState({
    set_email_verification: false,
    unset_email_verification: false,
  });
  const [schemeType, setSchemeType] = useState("General");
  const [emailInput, setEmailInput] = useState();
  const [isEmailMounted, setIsEmailMounted] = useState();
  const [isDisableNavigationMenuOption, setIsDisableNavigationMenuOption] = useState();
  const [proposalStatus, setProposalStatus] = useState();
  const [showModal, setShowModal] = useState();
  const [modalData, setModalData] = useState();
  const [isLoaderShowing, setIsLoaderShowing] = useState();
  const [signersCount, setSignersCount] = useState(0);

  const activeTabIndex = publishSchemes.indexOf(schemeType);

  const toggleAlert = () => setAlert({ ...alert, show: !alert.show });

  const copyToClipBoard = fieldId => {
    const textToCopy = document.getElementById(fieldId).value;
    navigator.clipboard.writeText(textToCopy);
    if (fieldId === publishFieldIds.link) {
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 3000);
    }
    if (fieldId === publishFieldIds.embed) {
      setEmbedCopied(true);
      setTimeout(() => setEmbedCopied(false), 3000);
    }
  };

  const generatePublishCode = () => {
    if (source === "publish-modal") {
      let documentDia = documentDetails?.data?.version?.rawdata?.metadata?.dimension;
      let paddingValue = documentDia?.height
        ? (parseFloat(documentDia.height) / parseFloat(documentDia.width)) * 100
        : 100;
      const publishUrl = `${process.env.PUBLIC_PAGE_BASE_URL}/p/${state.publish_id}`;

      document.getElementById(publishFieldIds.link).value = publishUrl;
      if (document.getElementById(publishFieldIds.embed))
        document.getElementById(
          publishFieldIds.embed
        ).value = `<div style="position: relative; width: 100%; height: 0; padding-top: ${paddingValue}%; padding-bottom: 0; box-shadow: 0 2px 8px 0 rgba(63,69,81,0.16); margin-top: 1.6em; margin-bottom: 0.9em; overflow: hidden; border-radius: 8px; will-change: transform;"> <iframe loading="lazy" style="position:absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0;margin: 0;" src="${publishUrl}?embed=true" frameborder="0"></iframe> </div>`;
    } else if (source === "email-modal") {
      const publishUrl = `${process.env.PUBLIC_PAGE_BASE_URL}/p/${state.publish_id}`;

      // Update the publishLink in the state
      let stateObj = { ...state };
      stateObj.email.payload.publishLink = publishUrl;
      setState(stateObj);
    }
  };

  const socialShareOpener = channel => {
    let urlToOpen = "";
    const message = encodeURIComponent(
      `${userInfo?.name} has shared you the following document: ${data?.document_name}`
    );
    const publishUrl = `${process.env.PUBLIC_PAGE_BASE_URL}/p/${state.publish_id}`;

    switch (channel) {
      case "facebook":
        urlToOpen = `https://www.facebook.com/sharer/sharer.php?u=${publishUrl}`;
        break;

      case "twitter":
        urlToOpen = `https://twitter.com/intent/tweet?text=${message}&url=${publishUrl}`;
        break;

      case "linkedin":
        urlToOpen = `https://www.linkedin.com/sharing/share-offsite/?url=${publishUrl}`;
        break;

      case "whatsapp":
        urlToOpen = `https://wa.me/?text=${message}%20${publishUrl}`;
        break;

      case "skype":
        urlToOpen = `https://web.skype.com/share?url=${publishUrl}&text=${message}`;
        break;

      default:
        break;
    }

    window.open(urlToOpen, "_blank", "noopener,noreferrer");
  };

  // Function to convert email array to input format
  const convertArrayToInputFormat = emailArray => {
    return emailArray?.join(", ");
  };

  const handleVerificationTypeClick = type => {
    if (verificationTypes[type] !== state.email_verification.verification_type_dropdown.selected.value) {
      updateState({ field: "email_type_dropdown", value: verificationTypes[type] });
    }
    //To retain input value between switch the type
    if (verificationTypes[type] === isEmailVerificationData?.key && isEmailVerificationData?.value) {
      const inputVal = convertArrayToInputFormat(isEmailVerificationData?.value);
      setEmailInput(inputVal);
    } else {
      setEmailInput("");
    }
  };

  const updateState = ({ field, type, e, value }) => {
    let stateObj = { ...state };

    if (field === "toggle_publish") {
      e.target.checked = stateObj.published;
      if (!stateObj.published) {
        stateObj.toggle_publish = true;
        if (docType === TYPE_PROPOSAL) {
          stateObj.proposal_settings.value = "";
          stateObj.proposal_settings.status = { name: "Live", color: "#fcc419", tooltipShow: false };
        }
        setState(stateObj);
        setIsMounted(true);
        dispatch(publishDocument([data.id]));
        setDisable({ ...disable, publish: true, unset_download: false, set_download: false });
      }
      if (stateObj.published) {
        setIsMounted(true);
        dispatch(unpublishDocument([data.id]));
        setDisable({ ...disable, publish: false, unpublish: true, unset_download: false, set_download: false });
      }
    }

    if (field === "toggle_allow_download") {
      if (paidCompanyInfo?.companyRole === COMPANY_SUPERADMIN && !paidCompanyInfo?.isPaid) {
        // Call showUpgrade function to show contextual upgrade modal based on your condition
        let docPagesMeta =
          contextData && Object.keys(contextData).length > 0
            ? { ...contextData }
            : { ...documentDetails?.data?.version?.rawdata?.contexts };
        showUpgrade("publishDownload", {
          docPagesMeta:
            docPagesMeta && Object.keys(docPagesMeta).length > 0
              ? docPagesMeta
              : { thumb: documentDetails?.data?.thumb },
        });
        if (_helpers?.modal?.toggle) _helpers.modal.toggle();
        return;
      }

      setIsMounted(true);
      dispatch(publishDocumentHandleDownload({ documentId: data.id, companyId, download: e.target.checked }));
      setDisable({ ...disable, unset_download: !e.target.checked, set_download: e.target.checked });
      e.target.checked = stateObj.download_enabled;
    }

    if (field === "toggle_set_password") {
      if (paidCompanyInfo?.companyRole === COMPANY_SUPERADMIN && !paidCompanyInfo?.isPaid) {
        // Call showUpgrade function to show contextual upgrade modal based on your condition
        showUpgrade("publishPassword");
        if (_helpers?.modal?.toggle) _helpers.modal.toggle();
        return;
      }
      if (stateObj.password_enabled) {
        e.target.checked = true;
        setIsMounted(true);
        dispatch(publishDocumentUnsetPassword([data.id]));
        setDisable({ ...disable, unset_password: true });
      }
      if (!stateObj.password_enabled) {
        stateObj.toggle_set_password = e.target.checked;
        if (!e.target.checked) {
          stateObj.password.value = "";
          stateObj.password.touched = false;
          stateObj.password.valid = false;
          stateObj.password.error = "";
        }
      }
      setState(stateObj);
    }

    if (field === "password") {
      let password = e?.target?.value ?? value;
      if (type === "change") {
        stateObj.password.value = password;
        stateObj.password.valid =
          password.length >= stateObj.password.validation.min_length &&
          password.length <= stateObj.password.validation.max_length;
        if (stateObj.password.valid) stateObj.password.error = "";
        if (!stateObj.password.valid && stateObj.password.touched)
          updateState({ field: "password", type: "blur", value: password });
      }
      if (type === "blur") {
        stateObj.password.touched = true;
        if (password.length === 0) stateObj.password.error = "Please enter a password";
        if (password.length > 0 && password.length < stateObj.password.validation.min_length)
          stateObj.password.error = `Password must be minimum ${stateObj.password.validation.min_length} characters`;
      }
      setState(stateObj);
    }

    if (field === "set_password") {
      if (stateObj.password.valid) {
        e.preventDefault();
        setIsMounted(true);
        let payload = {
          documentId: data.id,
          password: stateObj.password.value,
        };
        dispatch(publishDocumentSetPassword(payload));
        setDisable({ ...disable, set_password: true });
      }
    }

    if (field === "tab" && stateObj.tab !== value) {
      stateObj.tab = value;
      setState(stateObj);
    }

    if (field === "toggle_badge_enable") {
      if (
        (disable.set_badge_enable && !processEndTypes.badge.includes(type)) ||
        (disable.unset_badge_enable && !processEndTypes.badge.includes(type)) ||
        !Number.isFinite(paidCompanyInfo?.active_user_count)
      ) {
        return;
      }
      if (paidCompanyInfo?.companyRole === COMPANY_SUPERADMIN && !paidCompanyInfo?.isPaid) {
        // Call showUpgrade function to show contextual upgrade modal based on your condition
        let docPagesMeta =
          contextData && Object.keys(contextData).length > 0
            ? { ...contextData }
            : { ...documentDetails?.data?.version?.rawdata?.contexts };
        showUpgrade("publishBadge", {
          docPagesMeta:
            docPagesMeta && Object.keys(docPagesMeta).length > 0
              ? docPagesMeta
              : { thumb: documentDetails?.data?.thumb },
        });
        if (_helpers?.modal?.toggle) _helpers.modal.toggle();
        return;
      }

      setIsMounted(true);
      dispatch(publishDocumentHandleBadge({ documentId: data.id, hideBadge: e.target.checked }));
      setDisable({ ...disable, set_badge_enable: e.target.checked, unset_badge_enable: !e.target.checked });
      e.target.checked = stateObj.dochipo_badge_enabled;
    }

    if (field === "toggle_set_email_verification") {
      if (paidCompanyInfo?.companyRole === COMPANY_SUPERADMIN && !paidCompanyInfo?.isPaid) {
        // Call showUpgrade function to show contextual upgrade modal based on your condition
        showUpgrade("publishEmailVerification");
        if (_helpers?.modal?.toggle) _helpers.modal.toggle();
        return;
      }
      if (stateObj.email_verification_enabled) {
        e.target.checked = stateObj.toggle_email_verification;
        setIsEmailMounted(true);
        dispatch(publishDocumentEmailVerification({ documentId: data.id, verification: false }));
        setDisableEmail({ ...disableEmail, unset_email_verification: true, set_email_verification: false });
      }
      if (!stateObj.email_verification_enabled) {
        e.target.checked = stateObj.toggle_email_verification;
        setIsEmailMounted(true);
        let payload = { key: "Any Email" };
        dispatch(publishDocumentEmailVerification({ payLoad: payload, documentId: data.id, verification: true }));
        setDisableEmail({ ...disableEmail, set_email_verification: true, unset_email_verification: false });
      }
      setState(stateObj);
    }

    if (field === "toggle_enable_follow_up_reminders") {
      if (!isUserDocumentOwner) return;
      if (!paidCompanyInfo?.isPaid) {
        // Call showUpgrade function to show contextual upgrade modal based on your condition
        let docPagesMeta =
          contextData && Object.keys(contextData).length > 0
            ? { ...contextData }
            : { ...documentDetails?.data?.version?.rawdata?.contexts };
        showUpgrade("enableFollowUpReminders", {
          docPagesMeta:
            docPagesMeta && Object.keys(docPagesMeta).length > 0
              ? docPagesMeta
              : { thumb: documentDetails?.data?.thumb },
        });
        // showUpgrade("enableFollowUpReminders", { docPagesMeta: contextData });
        if (_helpers?.modal?.toggle) _helpers.modal.toggle();
        return;
      }
      setIsMounted(true);
      dispatch(proposalEnableFollowUpReminder({ documentId: data.id, isFollowUp: e.target.checked }));
      setDisable({ ...disable, set_follow_up_reminder: e.target.checked, unset_follow_up_reminder: !e.target.checked });
      e.target.checked = stateObj.enabled_follow_up;
    }

    if (field === "set_email_verification") {
      if (stateObj.email_verification.valid) {
        e.preventDefault();
        setIsEmailMounted(true);
        let payload = {
          key: stateObj.email_verification.verification_type_dropdown.selected.value,
          value: stateObj.email_verification.value,
        };
        dispatch(publishDocumentEmailVerification({ payLoad: payload, documentId: data.id, verification: true }));
        setDisableEmail({ ...disableEmail, set_email_verification: true, unset_email_verification: false });
      }
    }

    if (field === "verify_email") {
      let emails = e?.target?.value ?? value;
      setEmailInput(emails);
      const emailArray = emails.split(",").map(email => email.trim());
      stateObj.email_verification.value = emailArray;

      // to validate email
      const validateEmail = email => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return emailPattern.test(email);
      };

      // to validate email domain
      const validateEmailDomain = email => {
        const domainPattern = /^[a-zA-Z][a-zA-Z0-9-]*(\.[a-zA-Z]{2,})+$/;
        return domainPattern.test(email);
      };

      let allValid;

      if (stateObj.email_verification.verification_type_dropdown.selected.value === "Specific Email") {
        // Validate all emails with specific email validation
        allValid = emailArray.every(email => validateEmail(email));
      } else if (stateObj.email_verification.verification_type_dropdown.selected.value === "Email Domain") {
        // Validate all emails' domains
        allValid = emailArray.every(email => validateEmailDomain(email));
      }

      //Check if both list are equal
      const areArraysEqual = (arr1, arr2) => {
        if (arr1.length !== arr2.length) return false;
        return arr1.sort().every((value, index) => value === arr2.sort()[index]);
      };
      // Check for duplicates within the inputArray itself
      const hasDuplicatesInInput = new Set(emailArray).size !== emailArray.length;
      const storedEmailArray = isEmailVerificationData?.value || []; // Existing stored emails
      //Check if duplicate or equal
      const isDuplicateOrEqual = areArraysEqual(emailArray, storedEmailArray) || hasDuplicatesInInput;
      // Make the validity true or false
      if (allValid && !isDuplicateOrEqual) {
        stateObj.email_verification.valid = true;
      } else {
        stateObj.email_verification.valid = false;
      }
      setState(stateObj);
    }

    if (field === "email_type_dropdown") {
      stateObj.email_verification.verification_type_dropdown.selected = { name: value, value: value };
      setState(stateObj);
      if (value === "Any Email" && isEmailVerificationData?.key !== value) {
        setIsEmailMounted(true);
        let payload = { key: "Any Email" };
        dispatch(publishDocumentEmailVerification({ payLoad: payload, documentId: data.id, verification: true }));
        setDisableEmail({ ...disableEmail, set_email_verification: true });
      }
    }

    if (field === "publish_proposal_settings") {
      if (stateObj.proposal_settings.value !== e) {
        if (e !== "") {
          stateObj.proposal_settings.value = e;
          setState(stateObj);

          let day, month, year;

          // Step 1: Parse according to format
          if (dateFormat === "DD/MM/YYYY") {
            [day, month, year] = e.split("/").map(Number);
          } else if (dateFormat === "MM/DD/YYYY") {
            [month, day, year] = e.split("/").map(Number);
          } else {
            return;
          }

          // Step 2: Quick sanity check (numbers must exist and be in range)
          if (!day || !month || !year || month < 1 || month > 12 || day < 1 || day > 31) {
            return;
          }

          // Step 3: Build date and validate
          const dateObj = new Date(year, month - 1, day);

          if (dateObj.getFullYear() !== year || dateObj.getMonth() !== month - 1 || dateObj.getDate() !== day) {
            return;
          }

          const isoString = dateObj.toString();
          const date = new Date(isoString);
          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
          const d = String(date.getDate()).padStart(2, "0");
          let formattedDate = `${y}-${m}-${d}`;

          // Final strict check (YYYY-MM-DD must be valid)
          if (!/^\d{4}-\d{2}-\d{2}$/.test(formattedDate)) {
            return;
          } else {
            let payload = {
              document_id: documentId,
              expiration: formattedDate,
            };

            dispatch(updateDocumentExpiryDate(payload));
          }
        } else {
          if (stateObj.proposal_settings.value.length === 1) {
            stateObj.proposal_settings.value = "";
            setState(stateObj);
            dispatch(unsetDocumentExpiryDate(documentId));
          }
        }
      }
    }

    if (field === "proposal_status") {
      if (source === "publish-modal") document.querySelector(".publish-modal").style.display = "none";

      if (e.name === "Declined" || e.name === "Live") {
        setShowModal(true);
        setModalData(e);
      } else {
        updateProposalStatus(e);
      }
    }

    if (field === "toggle_proposal_show_navigation") {
      if (stateObj.proposal_show_navigation_enabled) {
        e.target.checked = !stateObj.toggl_proposal_show_navigation_enabled;
        stateObj.toggl_proposal_show_navigation_enabled = !stateObj.toggl_proposal_show_navigation_enabled;
      }
      if (!stateObj.proposal_show_navigation_enabled) {
        e.target.checked = !stateObj.toggl_proposal_show_navigation_enabled;
        stateObj.toggl_proposal_show_navigation_enabled = !stateObj.toggl_proposal_show_navigation_enabled;
      }
      setState(stateObj);

      let payload = {
        document_id: documentId,
        navigation: stateObj.toggl_proposal_show_navigation_enabled,
      };

      dispatch(toggleNavigation(payload));
    }
  };

  const postApiCallActions = () => {
    let stateObj = { ...state };
    if (type === DOCUMENT_PUBLISH_SUCCESS) {
      setIsMounted(false);
      documentInfo.set(data, { publish_id: publish_id });
      document.getElementById("document-publish-toggle").checked = true;
      stateObj.published = true;
      stateObj.publish_id = publish_id;
      stateObj.toggle_publish = true;
      setState(stateObj);
      // check is web socket is in ready state
      if (webSocket?.readyState === 1) {
        const subscribe = { type: PUBLISH_DOCUMENT, data, publish_id: publish_id };
        webSocket.send(JSON.stringify(subscribe));
      }
    }

    if (type === DOCUMENT_PUBLISH_HANDLE_DOWNLOAD_SUCCESS) {
      setIsMounted(false);
      documentInfo.set(data, { download: disable.set_download });
      document.getElementById("document-publish-link-toggle-allow-download").checked = disable.set_download;
      setDisable({ ...disable, set_download: false, unset_download: false });

      stateObj.download_enabled = disable.set_download;
      setState(stateObj);
      // check is web socket is in ready state
      if (webSocket?.readyState === 1) {
        const subscribe = { type: PUBLISH_DOCUMENT_DOWNLOAD, data, download: disable.set_download };
        webSocket.send(JSON.stringify(subscribe));
      }
    }

    if (type === DOCUMENT_PUBLISH_SET_PASSWORD_SUCCESS) {
      setIsMounted(false);
      documentInfo.set(data, { password: true });
      document.getElementById("document-publish-password").value = "";
      stateObj.password_enabled = true;
      stateObj.toggle_set_password = true;
      stateObj.password.value = "";
      stateObj.password.placeholder = "******";
      stateObj.password.touched = false;
      stateObj.password.valid = false;
      stateObj.password.error = "";
      stateObj.set_password_button_label = "Change";
      setState(stateObj);
      setIsPasswordSuccessResponse("Your password has been set");
      setTimeout(() => {
        setIsPasswordSuccessResponse("");
      }, 3000);
      setDisable({ ...disable, set_password: false });
      // check is web socket is in ready state
      if (webSocket?.readyState === 1) {
        const subscribe = { type: PUBLISH_DOCUMENT_PASSWORD, data, password: true };
        webSocket.send(JSON.stringify(subscribe));
      }
    }
    if (type === DOCUMENT_PUBLISH_UNSET_PASSWORD_SUCCESS) {
      setIsMounted(false);
      documentInfo.set(data, { password: null });
      document.getElementById("document-publish-link-toggle-setpassword").checked = false;
      stateObj.password_enabled = false;
      stateObj.toggle_set_password = false;
      stateObj.password.value = "";
      stateObj.password.placeholder = `Minimum ${stateObj.password.validation.min_length} characters`;
      stateObj.password.touched = false;
      stateObj.password.valid = false;
      stateObj.password.error = "";
      stateObj.set_password_button_label = "Save";
      setState(stateObj);
      setDisable({ ...disable, unset_password: false });
      // check is web socket is in ready state
      if (webSocket?.readyState === 1) {
        const subscribe = { type: PUBLISH_DOCUMENT_PASSWORD, data, password: null };
        webSocket.send(JSON.stringify(subscribe));
      }
    }
    if (type === DOCUMENT_UNPUBLISH_SUCCESS) {
      setIsMounted(false);
      documentInfo.set(data, { publish_id: null });
      documentInfo.set(data, { password: null });
      documentInfo.set(data, { download: null });
      documentInfo.set(data, { publish_email_verification: null });
      document.getElementById("document-publish-toggle").checked = false;
      initialState.published = false;
      initialState.password_enabled = false;
      initialState.publish_id = "";
      initialState.toggle_publish = false;
      initialState.toggle_set_password = false;
      initialState.password.placeholder = `Minimum ${stateObj.password.validation.min_length} characters`;
      initialState.set_password_button_label = "Save";
      initialState.download_enabled = false;
      initialState.email_verification_enabled = false;
      initialState.email_verification.value = "";
      initialState.email_verification.displayValue = "";
      initialState.email_verification.placeholder = "neel@gmail.com, sam@gmail.com";
      initialState.email_verification.verification_type_dropdown.selected.name = "Any Email";
      initialState.email_verification.verification_type_dropdown.selected.value = "Any Email";
      initialState.enabled_follow_up = false;
      setEmailInput("");
      setState(initialState);
      setDisable({ ...disable, unpublish: false });
      // check is web socket is in ready state
      if (webSocket?.readyState === 1) {
        const subscribe = { type: UNPUBLISH_DOCUMENT, data, publish_id: null, password: null, download: null };
        webSocket.send(JSON.stringify(subscribe));
      }
    }
    if (type === DOCUMENT_PUBLISH_HANDLE_BADGE_SUCCESS) {
      setIsMounted(false);
      documentInfo.set(data, { hide_badge: disable.set_badge_enable });
      document.getElementById("document-toggle-dochipo-badge").checked = disable.set_badge_enable;
      setDisable({ ...disable, set_badge_enable: false, unset_badge_enable: false });

      stateObj.dochipo_badge_enabled = disable.set_badge_enable;
      setState(stateObj);
      // To Update in company setting
      dispatch(getCompanyInfo(companyId));
    }

    if (type === FOLLOW_UP_REMINDER_DOCUMENT_SUCCESS) {
      setIsMounted(false);
      document.getElementById("enable-follow-up-reminder-toggle").checked = disable.set_follow_up_reminder;
      setDisable({ ...disable, set_follow_up_reminder: false, unset_follow_up_reminder: false });

      stateObj.enabled_follow_up = disable.set_follow_up_reminder;
      setState(stateObj);

      // To Update in Document Details
      dispatch(fetchDocumentDetails(data.id));
    }

    if (errorTypes.includes(type)) {
      setIsMounted(false);
      setIsEmailMounted(false);
      setAlert({ ...alert, show: true, type: "error" });
    }
  };

  const postEmailApiCallaction = () => {
    let stateObj = { ...state };
    if (type === DOCUMENT_PUBLISH_EMAIL_VERIFICATION_SUCCESS) {
      setIsEmailMounted(false);

      if (disableEmail.unset_email_verification) {
        documentInfo.set(data, {
          email_verification: null,
        });
        document.getElementById("document-publish-email-verfication").checked = false;
        stateObj.email_verification_enabled = false;
        stateObj.toggle_email_verification = false;
        stateObj.email_verification.placeholder = "neel@gmail.com, sam@gmail.com";
        stateObj.email_verification.value = "";
        stateObj.email_verification.verification_type_dropdown.selected.name = "Any Email";
        stateObj.email_verification.verification_type_dropdown.selected.value = "Any Email";
        setEmailInput("");
        setDisableEmail({ ...disableEmail, set_email_verification: false, unset_email_verification: false });
      } else if (
        disableEmail.set_email_verification &&
        stateObj.email_verification.verification_type_dropdown.selected.value == "Any Email"
      ) {
        documentInfo.set(data, {
          email_verification: {
            key: stateObj.email_verification.verification_type_dropdown.selected.value,
          },
        });
        document.getElementById("document-publish-email-verfication").checked = true;
        stateObj.email_verification_enabled = true;
        stateObj.toggle_email_verification = true;
        stateObj.email_verification.placeholder = "neel@gmail.com, sam@gmail.com";
        stateObj.email_verification.value = "";
        setEmailInput("");
        setDisableEmail({ ...disableEmail, set_email_verification: false, unset_email_verification: false });
      } else {
        documentInfo.set(data, {
          email_verification: {
            key: stateObj.email_verification.verification_type_dropdown.selected.value,
            value: stateObj.email_verification.value,
          },
        });
        stateObj.email_verification_enabled = true;
        stateObj.toggle_email_verification = true;
        stateObj.email_verification.valid = false;
        setDisableEmail({ ...disableEmail, set_email_verification: false, unset_email_verification: false });
      }
      setState(stateObj);
    }
  };

  const updateProposalStatus = e => {
    let stateObj = { ...state };

    stateObj.proposal_settings.status = e;
    setState(stateObj);

    let payload = {
      document_id: documentId,
      status: e.name === "Accepted" ? "signed" : e.name.toLowerCase(),
    };

    dispatch(updateDocumentSignedStatus(payload)).then(r => {
      setShowModal(false);
      if (source === "publish-modal") _helpers?.modal?.toggle();

      // after change status lock the editor
      if (document.getElementById("editorBody")) {
        // proposal is published
        if (e.name === "Live") {
          contextData.setIsDocumentSigned(false);
          contextData.setShowModalStatus(false);
        }
        // proposal is fully accepeted
        else if (e.name === "Accepted") {
          contextData.setIsDocumentSigned("full");
          contextData.setShowModalStatus(true);
          contextData.setSignedDate(r.data);
        }
        // Proposal is decliened
        else if (e.name === "Declined") {
          contextData.setIsDocumentSigned("declined");
          contextData.setShowModalStatus(true);
          contextData.setSignedDate(r.data);
        }
      }
      // from document page list view
      else if (document.querySelector(".document-page.list-view")) {
        _helpers.gridView.fetch.setPayload({ ..._helpers.gridView.fetch.payload, page: 1 });
      }
      // from document page tiles or grid view
      else {
        documentInfo.set(data, { document_status: payload.status });
      }
    });
  };

  const handlePreviewClick = e => {
    e.preventDefault();
    window.open(state.email.payload.publishLink, "_blank");
  };

  useEffect(() => {
    if (isMounted && type) postApiCallActions();
  }, [type, isMounted]);

  useEffect(() => {
    if (isEmailMounted && type) postEmailApiCallaction();
  }, [type, isEmailMounted]);

  useEffect(() => {
    if (state.published && userInfo && schemeType === "General") generatePublishCode();
    if (
      state.published &&
      userInfo &&
      ["Other Settings", "Proposal Settings"].includes(schemeType) &&
      source === "publish-modal"
    ) {
      const publishUrl = `${process.env.PUBLIC_PAGE_BASE_URL}/p/${state.publish_id}`;
      document.getElementById(publishFieldIds.link).value = publishUrl;
    }
  }, [state.published, userInfo, schemeType]);

  useEffect(() => {
    if (userInfo) setIsUserDocumentOwner(data?.permission === "OWNER");
  }, [userInfo]);

  useEffect(() => {
    if (!documentDetails && documentDetails?.data?.id !== data.id) dispatch(fetchDocumentDetails(data.id));
  }, [data.id]);

  useEffect(() => {
    if (state.email_verification.displayValue) {
      const inputVal = convertArrayToInputFormat(state.email_verification.displayValue);
      setEmailInput(inputVal);
    }
  }, [state.email_verification.displayValue]);

  useEffect(() => {
    // load current status, expiry date and show menu value when modal open
    let e =
      !documentDetails?.data?.proposal?.status ||
      documentDetails?.data?.proposal?.status === "live" ||
      documentDetails?.data?.proposal?.status === "partially_signed"
        ? { name: "Live", color: "#fcc419", tooltipShow: false }
        : documentDetails?.data?.proposal?.status === "signed"
        ? { name: "Accepted", color: "#40c057", tooltipShow: false, disableName: false }
        : { name: "Declined", color: "#b9310c", tooltipShow: false, disableName: false };

    const input = documentDetails?.data?.proposal?.expired_on;
    let expiration_date;
    if (input) {
      const date = new Date(input * 1000);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const year = date.getFullYear();

      if (dateFormat === "MM/DD/YYYY") {
        expiration_date = `${month}/${day}/${year}`;
      } else expiration_date = `${day}/${month}/${year}`;
    }

    let stateObj = { ...state };

    stateObj.proposal_settings.status = e;

    stateObj.enabled_follow_up = documentDetails?.data?.proposal?.followup_reminder || false;

    if (expiration_date) stateObj.proposal_settings.value = expiration_date;
    else stateObj.proposal_settings.value = "";
    stateObj.toggl_proposal_show_navigation_enabled =
      documentDetails?.data?.proposal?.hide_navigation !== undefined
        ? !documentDetails?.data?.proposal?.hide_navigation
        : false;

    setState(stateObj);
  }, [documentDetails]);

  useEffect(() => {
    if (schemeType === "Other Settings" && docType === TYPE_PROPOSAL) {
      document.getElementById("proposal_show_navigation_menu").checked = state.toggl_proposal_show_navigation_enabled;
    }
  }, [schemeType]);

  useEffect(() => {
    if (!userInfo) dispatch(getUserInfo());

    if (docType === TYPE_PROPOSAL) {
      if (document.getElementById("editorBody")) {
        dispatch(fetchDocumentDetails(documentId, false, "proposal_publish_status"));

        // set navigation menu disable if block title is not set
        let editorBlocks = contextData.blockNodes;

        setIsDisableNavigationMenuOption(true);
        for (const item of editorBlocks) {
          if (item.blockName) {
            setIsDisableNavigationMenuOption(false);
            break;
          }
        }
      } else if (state.published) setIsLoaderShowing(true);

      // if there is no signer in the document then accept button in publish modal will enable or else disable
      dispatch(fetchSignerList(documentId)).then(r => {
        let status;

        if (r.data.data.length === 0) {
          status = [
            { name: "Live", color: "#fcc419", tooltipShow: false, disableName: false },
            { name: "Accepted", color: "#40c057", tooltipShow: false, disableName: false },
            { name: "Declined", color: "#b9310c", tooltipShow: false, disableName: false },
          ];
        } else {
          setSignersCount(r.data.data.length);
          status = [
            { name: "Live", color: "#fcc419", tooltipShow: false, disableName: false },
            { name: "Accepted", color: "#40c057", tooltipShow: true, disableName: true },
            { name: "Declined", color: "#b9310c", tooltipShow: false, disableName: false },
          ];
        }

        setProposalStatus(status);
      });
    }
  }, []);

  useEffect(() => {
    if (documentrawData && docType === TYPE_PROPOSAL) {
      // set navigation menu disable if block title is not set
      let editorBlocks = documentrawData.rawdata.contexts.blockNodes;
      setIsDisableNavigationMenuOption(true);
      for (const item of editorBlocks) {
        if (item.blockName) {
          setIsDisableNavigationMenuOption(false);
          break;
        }
      }
    }
  }, [documentrawData]);

  useEffect(() => {
    if (docType === TYPE_PROPOSAL && _helpers?.proposalSignedStatus) {
      setIsLoaderShowing(false);
    }
  }, [_helpers?.proposalSignedStatus]);

  return (
    <>
      {source === "publish-modal" && (
        <>
          {state.published && (
            <>
              <h6 className={style["fw-7"]} style={{ display: isLoaderShowing ? "none" : "block" }}>
                Share Link
              </h6>
              <div className={style["copy-url"]} style={{ display: isLoaderShowing ? "none" : "block" }}>
                <Input
                  cssModule={style}
                  returnType="noGroup"
                  type="text"
                  className={cx(style["publish-link"])}
                  id={publishFieldIds.link}
                  readOnly
                />
                <div className={style["right"]}>
                  {!linkCopied && (
                    <Button color="primary" onClick={() => copyToClipBoard(publishFieldIds.link)}>
                      Copy
                    </Button>
                  )}
                  {linkCopied && <Button color="primary">Copied</Button>}
                </div>
              </div>
            </>
          )}

          {!state.published && (
            <p className={style["mb-0"]}>Publish to create a shareable link. Only people with the link can view this document.</p>
          )}
        </>
      )}

      {source === "email-modal" && (
        <div
          className={cx(style["publishTool"], {
            [style["inactivePublishUser"]]: !isUserDocumentOwner,
          })}>
          <div className={cx(style["d-flex"], style["align-items-center"], style["mb-2"])}>
            <h6 className={cx(style["fw-6"], style["mb-0"])}>Document Link</h6>
            <span className={cx(style["custom-tooltip"], style["ms-2"], style["d-flex"])}>
              <Icon additionalclass={"font-base"} icon="ui-info" />
              <div className={cx(style["custom-tooltip-content"], style["bottom"], style["mt-1"])}>
                The document link will be added to <br />
                your email body automatically
              </div>
            </span>
          </div>

          {state.published && (
            <div className={style["publish-details"]}>
              <div className={style["copy-url"]}>
                <Input
                  cssModule={style}
                  returnType="noGroup"
                  type="text"
                  className={cx(style["publish-link"])}
                  defaultValue={state.email.payload.publishLink}
                  readOnly
                />
                <div className={cx(style["text-right"], style["my-2"], style["clearfix"])}>
                  <div className={cx(style["d-flex"], style["justify-content-end"])}>
                    <Link
                      to="#"
                      onClick={handlePreviewClick}
                      className={cx(style["color-black"], style["d-flex"], style["align-items-center"])}>
                      <Icon icon="eye2" additionalclass={"me-2"} /> Preview
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {isLoaderShowing && (
        <>
          <ColumnLayoutLoader {...loaderConfig} />
          <SingleLineLoader width={75} height="34px" />
          <SingleLineLoader width={25} height="24px" />
        </>
      )}

      {!isLoaderShowing && (
        <div className={cx(style["publishTool"], { [style["inactivePublishUser"]]: !isUserDocumentOwner })}>
          {source === "publish-modal" && (
            <div className={cx(style["d-flex"], style["align-items-center"], { [style["mb-n4"]]: !state.published })}>
              <div
                className={cx(style["form-check"], style["form-switch"], style["my-4"], {
                  [style["disable"]]:
                    contextData.isDocumentSigned === "partial" ||
                    contextData.isDocumentSigned === "full" ||
                    _helpers.proposalSignedStatus === "partially_signed" ||
                    _helpers.proposalSignedStatus === "signed",
                })}>
                <Input
                  cssModule={style}
                  returnType="noGroup"
                  type="checkbox"
                  className={style["form-check-input"]}
                  id="document-publish-toggle"
                  label="Publish"
                  defaultChecked={state.published}
                  onChange={e => updateState({ field: "toggle_publish", e: e })}
                  disabled={
                    !isUserDocumentOwner ||
                    disable.unpublish ||
                    disable.set_password ||
                    disable.unset_password ||
                    contextData.isDocumentSigned === "partial" ||
                    contextData.isDocumentSigned === "full" ||
                    _helpers.proposalSignedStatus === "partially_signed" ||
                    _helpers.proposalSignedStatus === "signed"
                  }
                />
              </div>

              {!isUserDocumentOwner && (
                <div className={cx(style["ms-2"], style["info-link"])}>
                  <span className={style["color-33"]}>
                    <Icon icon="information" />
                  </span>
                  <div className={cx(style["info-link-content"], style["rounded"], style["shadow-sm"])}>
                    Only the Document Owner can make changes to the Publish settings.
                  </div>
                </div>
              )}

              {isUserDocumentOwner && state.published && (
                <div className={cx(style["custom-tooltip"], style["ms-2"])}>
                  <Icon icon="ui-info" additionalclass="font-14" />
                  <div className={cx(style["custom-tooltip-content"], style["text-center"], style["bottom"])}>
                    If you turn this off, the page <br></br> will be unpublished
                  </div>
                </div>
              )}

              <ProcessLoader
                isOpen={
                  (disable.publish &&
                    !processEndTypes.publish.includes(type) &&
                    !state.published &&
                    state.toggle_publish) ||
                  (disable.unpublish && !processEndTypes.unpublish.includes(type))
                }
              />
            </div>
          )}

          {state.published && (
            <>
              <TabSchemeSelector
                schemeTypeArray={publishSchemes}
                setSchemeType={setSchemeType}
                schemeType={schemeType}
                activeTabIndex={activeTabIndex}
              />
              <TabContent className={cx(style["p-0"], style["overflow-visible"])}>
                {schemeType === "General" && (
                  <TabPane tabId="general_setting" className="d-block">
                    <div className={style["publish-details"]}>
                      <div className={cx(style["d-flex"], style["align-items-center"], style["mb-3"])}>
                        <div
                          className={cx(style["form-check"], style["form-switch"], {
                            [style["disable"]]:
                              contextData.isDocumentSigned === "full" || _helpers.proposalSignedStatus === "signed",
                          })}>
                          <Input
                            cssModule={style}
                            returnType="noGroup"
                            type="checkbox"
                            className={cx(style["form-check-input"], {
                              [style["disable"]]:
                                contextData.isDocumentSigned === "full" || _helpers.proposalSignedStatus === "signed",
                            })}
                            id="document-publish-link-toggle-allow-download"
                            label="Allow Viewers to Download"
                            defaultChecked={state.download_enabled}
                            onChange={e => updateState({ field: "toggle_allow_download", e: e })}
                            disabled={
                              !isUserDocumentOwner ||
                              contextData.isDocumentSigned === "full" ||
                              _helpers.proposalSignedStatus === "signed"
                            }
                          />
                        </div>
                        <div className={cx(style["custom-tooltip"], style["ms-2"], style["d-flex"])}>
                          <Icon icon="ui-info" additionalclass="font-14" />
                          <div className={cx(style["custom-tooltip-content"], style["text-center"], style["bottom"])}>
                            Allow viewers to <br></br> download in PDF format
                          </div>
                        </div>
                        <img alt="premium" width={20} src={Crown} className={cx(style["ms-2"])} />
                        <ProcessLoader
                          isOpen={
                            (disable.set_download && !processEndTypes.download.includes(type)) ||
                            (disable.unset_download && !processEndTypes.download.includes(type))
                          }
                          wrapperClass="ms-2"
                        />
                      </div>

                      <div className={cx(style["d-flex"], style["align-items-center"], style["mb-4"])}>
                        <div className={cx(style["form-check"], style["form-switch"])}>
                          <Input
                            cssModule={style}
                            returnType="noGroup"
                            type="checkbox"
                            className={style["form-check-input"]}
                            id="document-publish-link-toggle-setpassword"
                            label="Set Password"
                            defaultChecked={state.password_enabled}
                            onChange={e => updateState({ field: "toggle_set_password", e: e })}
                            disabled={!isUserDocumentOwner || disable.set_password || isPasswordSuccessResponse !== ""}
                          />
                        </div>
                        <div className={cx(style["custom-tooltip"], style["ms-2"], style["d-flex"])}>
                          <Icon icon="ui-info" additionalclass="font-14" />
                          <div className={cx(style["custom-tooltip-content"], style["text-center"])}>
                            Share document privately <br></br> with a password
                          </div>
                        </div>
                        <img alt="premium" width={20} src={Crown} className={cx(style["ms-2"])} />
                        <ProcessLoader
                          isOpen={
                            (disable.set_password && !processEndTypes.set_password.includes(type)) ||
                            (disable.unset_password && !processEndTypes.unset_password.includes(type))
                          }
                          wrapperClass="ms-2"
                        />
                      </div>

                      {state.toggle_set_password && (
                        <div className={cx(style["password-generation"])}>
                          <Form
                            className={cx(style["form-inline"], style["d-flex"])}
                            onKeyDown={e => preventSubmit(e)}
                            onSubmit={e => updateState({ field: "set_password", e: e })}>
                            <Input
                              cssModule={style}
                              returnType="formGroup"
                              type="password_length"
                              limit={state.password.validation.max_length}
                              length={state.password.value.length}
                              showerror={state.password.error}
                              showsuccess={isPasswordSuccessResponse}
                              id="document-publish-password"
                              placeholder={state.password.placeholder}
                              maxLength={state.password.validation.max_length}
                              onChange={e => updateState({ field: "password", type: "change", e: e })}
                              onBlur={e => updateState({ field: "password", type: "blur", e: e })}
                              disabled={
                                !isUserDocumentOwner || disable.set_password || isPasswordSuccessResponse !== ""
                              }
                            />
                            <Button
                              type="submit"
                              color="primary"
                              cssModule={style}
                              className={style["ms-auto"]}
                              disabled={
                                !isUserDocumentOwner ||
                                !state.password.valid ||
                                disable.set_password ||
                                disable.unset_password
                              }>
                              {state.set_password_button_label}
                            </Button>
                          </Form>
                        </div>
                      )}

                      {docType !== TYPE_PROPOSAL && source !== "email-modal" && (
                        <div className={cx(style["social-embed"], { [style["d-none"]]: state.toggle_set_password })}>
                          <Nav className={cx(style["nav-pills"], style["mb-3"])}>
                            <NavItem className={style["me-2"]}>
                              <NavLink
                                className={cx({ [style["active"]]: state.tab === "social_media" })}
                                onClick={() => updateState({ field: "tab", value: "social_media" })}>
                                <img src={thumbsUpSvg} alt="Social Media" /> Social Media
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={cx({ [style["active"]]: state.tab === "embed" })}
                                onClick={() => updateState({ field: "tab", value: "embed" })}>
                                <img src={sourceCodeSvg} alt="Embed" /> Embed
                              </NavLink>
                            </NavItem>
                          </Nav>
                          <TabContent activeTab={state.tab}>
                            <TabPane tabId="social_media">
                              <Row>
                                <Col sm="12">
                                  <ul className={style["social-publish"]}>
                                    {socialShareOptions.map(option => (
                                      <li key={`document_publish_${option.name}`}>
                                        <span
                                          className={cx(
                                            style[option.className],
                                            style["sharing-button"],
                                            style["custom-tooltip"]
                                          )}
                                          onClick={() => socialShareOpener(option.name)}>
                                          <Icon icon={option.iconClassName} />
                                          <div
                                            className={cx(
                                              style["custom-tooltip-content"],
                                              style["text-center"],
                                              style["bottom"],
                                              style["mt-4"]
                                            )}>
                                            {option.tooltip}
                                          </div>
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                </Col>
                              </Row>
                            </TabPane>
                            <TabPane tabId="embed">
                              <Row>
                                <Col sm="12">
                                  <div className={style["copy-url"]}>
                                    <Input
                                      cssModule={style}
                                      returnType="noGroup"
                                      type="textarea"
                                      id={publishFieldIds.embed}
                                      readOnly
                                    />
                                    <p className={cx(style["clearfix"], style["my-2"])}>
                                      {!embedCopied && (
                                        <Link to="#" onClick={() => copyToClipBoard(publishFieldIds.embed)}>
                                          <Icon icon="ui-clone2" /> Copy Code
                                        </Link>
                                      )}
                                      {embedCopied && <span>Copied to Clipboard</span>}
                                    </p>
                                  </div>
                                </Col>
                              </Row>
                            </TabPane>
                          </TabContent>
                        </div>
                      )}
                    </div>
                  </TabPane>
                )}
                {schemeType === "Proposal Settings" && (
                  <TabPane tabId="proposal_setting" className="d-block">
                    <Row className={cx(style["publish-details"])}>
                      <Col xs="7">
                        <h6 className={style["fw-6"]}>Proposal Expiration</h6>
                        <div className={cx(style["custom-date-picker"], style["mb-3"])}>
                          <Input
                            type="date_calendar"
                            id={"publishProposalSettings"}
                            defaultValue={state.proposal_settings.value ?? ""}
                            inputName={"Proposal Expiration"}
                            dateFormat={dateFormat}
                            usedForType="Proposal"
                            updateState={e => updateState({ field: "publish_proposal_settings", e: e })}
                          />
                        </div>
                      </Col>

                      <Col className={style["ms-n3"]}>
                        <div>
                          <h6 className={style["fw-6"]}>Proposal Status</h6>
                          <UncontrolledDropdown className={cx(style["w-100"], style["status"])}>
                            <DropdownToggle
                              caret
                              tag="a"
                              className={cx(style["rounded"], {
                                [style["disable"]]: state.proposal_settings.status.name === "Accepted",
                              })}>
                              <span className={cx(style["d-flex"], style["align-items-center"])}>
                                <span
                                  className={cx(style["color-info"], style["me-2"])}
                                  style={{ backgroundColor: state.proposal_settings.status.color }}></span>
                                <span>{state.proposal_settings.status.name}</span>
                              </span>
                              <Icon icon="ui-arrow-down" />
                            </DropdownToggle>
                            <DropdownMenu
                              className={cx(style["shadow"], style["border-0"], style["rounded"], style["w-100"])}>
                              {proposalStatus?.map((s, i) => (
                                <DropdownItem
                                  tag={"a"}
                                  key={i}
                                  className={cx({
                                    [style["active-item"]]: s.name === state.proposal_settings.status.name,
                                  })}
                                  onClick={() =>
                                    !s.disableName &&
                                    s.name !== state.proposal_settings.status.name &&
                                    updateState({ field: "proposal_status", e: s })
                                  }>
                                  <span
                                    className={cx(style["color-info"], style["me-2"])}
                                    style={{
                                      backgroundColor: s.color,
                                    }}></span>
                                  <span className={cx({ [style["disable"]]: s.disableName })}>
                                    {proposalStatus[i].name}
                                  </span>

                                  {s.tooltipShow && (
                                    <div className={cx(style["custom-tooltip"], style["ms-2"], style["d-flex"])}>
                                      <Icon icon="ui-info" additionalclass="font-14" />
                                      <div className={cx(style["custom-tooltip-content"], style["text-center"])}>
                                        You can’t manually change the status to <br></br> accepted if signature is
                                        enabled
                                      </div>
                                    </div>
                                  )}
                                </DropdownItem>
                              ))}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                )}
                {schemeType === "Other Settings" && (
                  <TabPane tabId="other_setting" className="d-block">
                    <div>
                      {docType === TYPE_PROPOSAL && (
                        <>
                          <div
                            className={cx(
                              style["d-flex"],
                              style["align-items-center"],
                              {
                                [style["inactiveNavigationMenu"]]:
                                  isDisableNavigationMenuOption || !isUserDocumentOwner,
                              },
                              style["mb-3"]
                            )}>
                            <div
                              id={`second-tooltip-proposal-navigation-menu`}
                              className={cx(style["form-check"], style["form-switch"])}>
                              <Input
                                cssModule={style}
                                returnType="noGroup"
                                type="checkbox"
                                className={style["form-check-input"]}
                                id="proposal_show_navigation_menu"
                                label="Show Navigation Menu"
                                defaultChecked={state.proposal_show_navigation_enabled}
                                value={state.proposal_show_navigation_enabled}
                                onChange={e => updateState({ field: "toggle_proposal_show_navigation", e: e })}
                                disabled={isDisableNavigationMenuOption || !isUserDocumentOwner}
                              />
                            </div>
                            <div className={cx(style["custom-tooltip"], style["ms-2"], style["d-flex"])}>
                              <Icon icon="ui-info" additionalclass="font-14" />
                              <div className={cx(style["custom-tooltip-content"], style["text-center"])}>
                                Please ensure you have <br></br> block titles set up
                              </div>
                            </div>
                          </div>
                          {isDisableNavigationMenuOption && (
                            <UncontrolledTooltip
                              placement="top"
                              target={`second-tooltip-proposal-navigation-menu`}
                              hideArrow={true}
                              innerClassName={"publish-tooltip-inner"}>
                              Please set up the block titles
                            </UncontrolledTooltip>
                          )}
                        </>
                      )}

                      {docType === TYPE_PROPOSAL && (
                        <>
                          <div
                            className={cx(style["d-flex"], style["align-items-center"], style["mb-3"], {
                              [style["inactiveEnableFollowup"]]:
                                state.proposal_settings.value === "" ||
                                signersCount < 1 ||
                                !isUserDocumentOwner ||
                                state.proposal_settings.status.name === "Accepted" ||
                                state.proposal_settings.status.name === "Declined",
                            })}>
                            <div
                              id={`tooltip-enable-follow-up-reminder-toggle`}
                              className={cx(style["form-check"], style["form-switch"])}>
                              <Input
                                cssModule={style}
                                returnType="noGroup"
                                type="checkbox"
                                className={cx(style["form-check-input"])}
                                id="enable-follow-up-reminder-toggle"
                                label="Enable Follow-up Reminders"
                                defaultChecked={
                                  state.proposal_settings.status.name === "Declined" ? false : state.enabled_follow_up
                                }
                                onChange={e => updateState({ field: "toggle_enable_follow_up_reminders", e: e })}
                                disabled={
                                  state.proposal_settings.value === "" ||
                                  signersCount < 1 ||
                                  !isUserDocumentOwner ||
                                  state.proposal_settings.status.name === "Accepted" ||
                                  state.proposal_settings.status.name === "Declined"
                                }
                              />
                            </div>
                            <div className={cx(style["custom-tooltip"], style["ms-2"], style["d-flex"])}>
                              <Icon icon="ui-info" additionalclass="font-14" />
                              <div
                                className={cx(style["custom-tooltip-content"], style["text-center"])}>
                                DocHipo sends reminder emails <br></br> 3 and 1 day before expiry
                              </div>
                            </div>
                            <img alt="premium" width={20} src={Crown} className={cx(style["ms-2"])} />
                            <ProcessLoader
                              isOpen={
                                (disable.set_follow_up_reminder &&
                                  !processEndTypes.follow_up_reminder.includes(type)) ||
                                (disable.unset_follow_up_reminder && !processEndTypes.follow_up_reminder.includes(type))
                              }
                              wrapperClass="ms-2"
                            />
                          </div>
                          {(state.proposal_settings.value === "" || signersCount < 1) && (
                            <UncontrolledTooltip
                              placement="top"
                              target={`tooltip-enable-follow-up-reminder-toggle`}
                              hideArrow={true}
                              className={"enable-follow-up-reminder-tooltip"}
                              innerClassName={"enable-follow-up-reminder-tooltip-inner"}>
                              Please set up signers and proposal expiration
                            </UncontrolledTooltip>
                          )}
                        </>
                      )}

                      <div
                        className={cx(
                          style["d-flex"],
                          style["align-items-center"],
                          style["mb-3"],
                          style[
                            !(paidCompanyInfo?.companyRole === COMPANY_SUPERADMIN)
                              ? "inactiveCompanyBadge"
                              : "activeCompanyBadge"
                          ]
                        )}>
                        <div className={cx(style["form-check"], style["form-switch"])}>
                          <Input
                            cssModule={style}
                            returnType="noGroup"
                            type="checkbox"
                            className={style["form-check-input"]}
                            id="document-toggle-dochipo-badge"
                            label="Hide DocHipo Badge"
                            defaultChecked={state.dochipo_badge_enabled}
                            onChange={e => updateState({ field: "toggle_badge_enable", e: e })}
                            disabled={!(paidCompanyInfo?.companyRole === COMPANY_SUPERADMIN)}
                          />
                        </div>
                        <div className={cx(style["custom-tooltip"], style["ms-2"], style["d-flex"])}>
                          <Icon icon="ui-info" additionalclass="font-14" />
                          <div className={cx(style["custom-tooltip-content"], style["text-center"], style["mt-n2"])}>
                            Hide DocHipo badge from the <br></br> page footer of all published pages. <br></br> Only
                            Admin can manage this
                          </div>
                        </div>
                        <img alt="premium" width={20} src={Crown} className={cx(style["ms-2"])} />
                        <ProcessLoader
                          isOpen={
                            (disable.set_badge_enable && !processEndTypes.badge.includes(type)) ||
                            (disable.unset_badge_enable && !processEndTypes.badge.includes(type))
                          }
                          wrapperClass="ms-2"
                        />
                      </div>

                      <div
                        className={cx(style["d-flex"], style["align-items-center"], {
                          [style["mb-4"]]:
                            state.email_verification.verification_type_dropdown.selected.value !== "Any Email",
                        })}>
                        <div className={cx(style["form-check"], style["form-switch"])}>
                          <Input
                            cssModule={style}
                            returnType="noGroup"
                            type="checkbox"
                            className={style["form-check-input"]}
                            id="document-publish-email-verfication"
                            label="Email Verification"
                            defaultChecked={state.email_verification_enabled}
                            onChange={e => updateState({ field: "toggle_set_email_verification", e: e })}
                            disabled={
                              !isUserDocumentOwner ||
                              paidCompanyInfo?.isLoading ||
                              authState?.companyInfoLoading ||
                              (disable.set_badge_enable && !processEndTypes.badge.includes(type)) ||
                              (disable.unset_badge_enable && !processEndTypes.badge.includes(type))
                            }
                          />
                        </div>
                        <div className={cx(style["custom-tooltip"], style["ms-2"], style["d-flex"])}>
                          <Icon icon="ui-info" additionalclass="font-14" />
                          <div className={cx(style["custom-tooltip-content"], style["text-center"])}>
                            Requires email address to <br></br> access the document
                          </div>
                        </div>
                        <img alt="premium" width={20} src={Crown} className={cx(style["ms-2"])} />

                        {state.email_verification_enabled && (
                          <div
                            className={cx(style["ms-3"], style["email-dropdown"], {
                              [style["disable"]]: !isUserDocumentOwner,
                            })}>
                            <UncontrolledDropdown className={cx(style["w-100"])}>
                              <DropdownToggle caret tag="a" className={style["rounded"]}>
                                <span>{state.email_verification.verification_type_dropdown.selected.value}</span>
                                <Icon icon="ui-arrow-down" additionalclass={"ms-1"} />
                              </DropdownToggle>
                              <DropdownMenu className={cx(style["shadow"], style["border-0"], style["rounded"])}>
                                {Object.keys(verificationTypes).map((p, i) => (
                                  <DropdownItem
                                    tag="a"
                                    key={i}
                                    className={cx({
                                      [style["active-item"]]:
                                        verificationTypes[p] ===
                                        state.email_verification.verification_type_dropdown.selected.value,
                                    })}
                                    onClick={() => handleVerificationTypeClick(p)}>
                                    {verificationTypes[p]}
                                  </DropdownItem>
                                ))}
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </div>
                        )}

                        <ProcessLoader
                          isOpen={
                            (disableEmail.set_email_verification &&
                              !processEndTypes.email_verification.includes(type)) ||
                            (disableEmail.unset_email_verification &&
                              !processEndTypes.email_verification.includes(type))
                          }
                          wrapperClass="ms-2"
                        />
                      </div>
                      {state.email_verification_enabled &&
                        state.email_verification.verification_type_dropdown.selected.value !== "Any Email" && (
                          <div className={style["multiple-email"]}>
                            <Form
                              onKeyDown={e => preventSubmit(e)}
                              onSubmit={e => updateState({ field: "set_email_verification", e: e })}>
                              <Input
                                className={{ [style["disable"]]: !isUserDocumentOwner }}
                                cssModule={style}
                                returnType="formGroup"
                                type="text"
                                id="document-publish-email-verify"
                                placeholder={
                                  !emailInput &&
                                  state.email_verification.verification_type_dropdown.selected.value !== "Email Domain"
                                    ? state.email_verification.placeholder
                                    : state.email_verification.email_domain_placeholder
                                }
                                onChange={e => updateState({ field: "verify_email", e: e })}
                                value={emailInput}
                              />
                              <div className={style["right"]}>
                                <Button
                                  type="submit"
                                  color="primary"
                                  cssModule={style}
                                  disabled={
                                    !state.email_verification.valid ||
                                    disableEmail.set_email_verification ||
                                    disableEmail.unset_email_verification ||
                                    !emailInput
                                  }>
                                  Save
                                </Button>
                              </div>
                            </Form>
                          </div>
                        )}
                    </div>
                  </TabPane>
                )}
              </TabContent>
            </>
          )}

          <FlashAlert isOpen={alert.show} toggle={toggleAlert} type={alert.type} wrapperClass="mt-3" />
        </div>
      )}

      {showModal && (
        <Modal
          showModal={showModal}
          setShowModal={setShowModal}
          component={ProposalStatusChangeModal}
          modalData={modalData}
          updateProposalStatus={updateProposalStatus}
        />
      )}
    </>
  );
};
Settings.propTypes = {
  source: PropTypes.String,
  document: PropTypes.object.isRequired,
  _helpers: PropTypes.object.isRequired,
  documentrawData: PropTypes.object,
};

export default Settings;
